export default __webpack_public_path__ + "static/media/import-csv-example.9ff5225d.csv";